export default __webpack_public_path__ + "static/media/vertical-foregrip-flat.03e18756.svg";